import { CodeRuntime } from "./client";
import { type Program, initialState } from "./contract";

let warming: Promise<void> | undefined;
export function prewarmCodeRuntime() {
  return (warming ??= (async () => {
    const runtime = new CodeRuntime();
    const program: Program = {
      title: "Runtime warm-up",
      objective: "Prepare trusted runtime assets",
      level: "A1",
      language: "en",
      passage: "",
      source: 'export default defineExercise({render(){return <activity activity="warm"/>}});',
      activities: [
        {
          id: "warm",
          prompt: "Ready",
          mode: "open",
          options: [],
          answers: [],
          hint: "",
          explanation: "",
        },
      ],
    };
    try {
      await runtime.call(program, initialState(), true);
    } finally {
      runtime.close();
    }
  })().catch(() => {
    warming = undefined;
  }));
}
